import { Exceptions } from "~/components/exceptions/exceptions";
import {
  ExceptionType,
  GetAdvisoriesDocument,
  ListExceptionGroupsDocument,
  LoadAssetDocument,
} from "~/operations";
import { useAssetOutlet } from "~/pages/inventory/asset";
import { ExceptionGroup } from "~/pages/findings/Exceptions/types";
import { ExceptionFindingsTable } from "~/components/ExceptionFindingsTable/ExceptionFindingsTable";
import {
  ExceptionFindingTableType,
  ExceptionFindingsTableException,
} from "~/components/ExceptionFindingsTable/exceptionFindigsTableTypes";

const EXCEPTION_TYPES: Map<string, ExceptionFindingTableType> = new Map([
  ["AssetCveException", "cve"],
  ["AssetCheckException", "check"],
  ["AssetAdvisoryException", "advisory"],
  ["AssetFexException", "fex"],
]);

export const AssetExceptionsWrapper = () => {
  const { exceptionGroups, space, assetId, loading, assetMrn } =
    useAssetOutlet();

  return (
    <Exceptions
      isLoading={loading}
      exceptionTypes={[
        ExceptionType.Security,
        ExceptionType.Cve,
        ExceptionType.Advisory,
        ExceptionType.Fex,
      ]}
      assetMrn={assetMrn}
      emptyStateType="check-exceptions"
      exceptionGroups={exceptionGroups}
      refetchQueries={[
        ListExceptionGroupsDocument,
        LoadAssetDocument,
        GetAdvisoriesDocument,
      ]}
      renderTable={(exceptionGroup: ExceptionGroup) => {
        const { exceptions } = exceptionGroup;
        const item = exceptions[0];
        const exceptionType = EXCEPTION_TYPES.get(item?.__typename);

        if (!item || !exceptionType) {
          return null;
        }

        const supportedExceptions = exceptions.filter((e) =>
          EXCEPTION_TYPES.has(e.__typename),
        ) as ExceptionFindingsTableException[];

        return (
          <ExceptionFindingsTable
            findingType={exceptionType}
            scope="asset"
            findings={supportedExceptions}
            contextProps={{ assetId, spaceId: space?.id }}
          />
        );
      }}
    />
  );
};
